import { Button, CircularProgress, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function EdgeTool({ title, link }) {
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [imageData, setImageData] = useState("");
  const [preset, setPreset] = useState("");
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [model, setModel] = useState("dalle");
  const [answerload, setAnswerload] = useState(false);
  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [machines, setMachines] = useState([]);
  const [compareLoad, setCompareLoad] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (file) {
      setIsFileUploaded(true);
      const reader = new FileReader();
      setError("File uploaded successfully");
      reader.onload = function (e) {
        const content = e.target.result;
        if (content.trim().startsWith("{") && content.trim().endsWith("}")) {
          try {
            const json = JSON.parse(content);
            setJsonData(json); // Store the parsed JSON in state
            console.log("Parsed JSON Data:", json);
          } catch (err) {
            console.error("Error parsing JSON:", err);
          }
        } else {
          console.error("File content is not valid JSON");
        }
      };
      reader.readAsText(file);
    }
  };

  // Machine State
  const [machine, setMachine] = useState({
    id: 1,
    machine_name: "",
    machine_function: "",
    year_of_installation: "",
    does_this_machine_use_a_plc: false,
    plc_type_or_model: "",
    is_the_plc_integrated_with_a_scada_system: false,
    scada_system: "",
    does_the_plc_support_modern_communication_protocols: false,
    protocols_in_use: "",
    available_ports: {
      status: false,
      additional_info_on_available_ports: "",
    },
    does_this_machine_have_an_associated_edge_computing_device: false, // Boolean for the checkbox
    edge_device_specifications: "", // String for the actual specifications
    data_processed: "",
    storage_capacity: "",
  });

  // Security Assessment State
  const [security_assessment, setsecurity_assessment] = useState({
    security_for_plcs_and_scada: {
      status: false,
      additional_info: "",
    },
    network_security: {
      status: false,
      additional_info: "",
    },
    secure_communication_protocols: {
      status: false,
      additional_info: "",
    },
    access_controls: {
      status: false,
      additional_info: "",
    },
    intrusion_detection_systems: {
      status: false,
      additional_info: "",
    },
  });

  const [
    network_and_communication_api_gateways,
    setnetwork_and_communication_api_gateways,
  ] = useState({
    network_support_api_communications_effectively: {
      status: false,
      additional_info: "",
    },
    api_gateways_to_ensure_smooth_data_flow_across_systems: {
      status: false,
      additional_info: "",
    },
  });

  const [security, setSecurity] = useState({
    security_measures_like_API_keys_or_tokens_used_for_API_access: {
      status: false,
      additional_info: "",
    },
    API_traffic_monitored_for_security_threats: {
      status: false,
      additional_info: "",
    },
  });

  // bussinesss assessment
  const [business_assessment, setbusiness_assessment] = useState({
    business_goals: {
      defined_business_goals: {
        status: false,
        additional_info: "",
      },
      kpis_to_improve: "",
    },
    use_cases: {
      oee_tracking: {
        status: false,
        additional_info: "",
      },
      predictive_maintenance: {
        status: false,
        additional_info: "",
      },
      real_time_production_monitoring: {
        status: false,
        additional_info: "",
      },
      digital_twin_technology: {
        status: false,
        additional_info: "",
      },
      lead_scoring_models: {
        status: false,
        additional_info: "",
      },
      customer_segmentation: {
        status: false,
        additional_info: "",
      },
      recommendation_engine: {
        status: false,
        additional_info: "",
      },
      inventory_optimization: {
        status: false,
        additional_info: "",
      },
      demand_forecasting_models: {
        status: false,
        additional_info: "",
      },
      real_time_supply_chain_visibility: {
        status: false,
        additional_info: "",
      },
    },
  });

  const [company_info, setcompany_info] = useState({
    company_name: "",
    industry: "",
    primary_contact_person: "",
    location: "",
  });

  // Handle Sign Out
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // Handle sign out error
    }
  }

  // Handle Input Change for Machine, Enterprise IT Systems, Security Assessment, and Data Management
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    const updateNestedState = (state, setState, path) => {
      setState((prevState) => {
        const updatedState = { ...prevState };
        let current = updatedState;

        for (let i = 0; i < path.length - 1; i++) {
          if (!current[path[i]]) {
            current[path[i]] = {}; // Ensure the object exists
          }
          current = current[path[i]];
        }

        current[path[path.length - 1]] = newValue;
        return updatedState;
      });
    };

    // Handling Business Assessment Fields (Already existing)
    if (
      name ===
      "security_measures_like_API_keys_or_tokens_used_for_API_access_status"
    ) {
      updateNestedState(security, setSecurity, [
        "security_measures_like_API_keys_or_tokens_used_for_API_access",
        "status",
      ]);
    } else if (
      name ===
      "security_measures_like_API_keys_or_tokens_used_for_API_access_info"
    ) {
      updateNestedState(security, setSecurity, [
        "security_measures_like_API_keys_or_tokens_used_for_API_access",
        "additional_info",
      ]);
    } else if (name === "API_traffic_monitored_for_security_threats_status") {
      updateNestedState(security, setSecurity, [
        "API_traffic_monitored_for_security_threats",
        "status",
      ]);
    } else if (name === "API_traffic_monitored_for_security_threats_info") {
      updateNestedState(security, setSecurity, [
        "API_traffic_monitored_for_security_threats",
        "additional_info",
      ]);
    }

    // Add the conditions for `network_and_communication_api_gateways`
    else if (name === "network_support_api_communications_effectively_status") {
      updateNestedState(
        network_and_communication_api_gateways,
        setnetwork_and_communication_api_gateways,
        ["network_support_api_communications_effectively", "status"],
      );
    } else if (name === "network_support_api_communications_effectively_info") {
      updateNestedState(
        network_and_communication_api_gateways,
        setnetwork_and_communication_api_gateways,
        ["network_support_api_communications_effectively", "additional_info"],
      );
    } else if (
      name === "api_gateways_to_ensure_smooth_data_flow_across_systems_status"
    ) {
      updateNestedState(
        network_and_communication_api_gateways,
        setnetwork_and_communication_api_gateways,
        ["api_gateways_to_ensure_smooth_data_flow_across_systems", "status"],
      );
    } else if (
      name === "api_gateways_to_ensure_smooth_data_flow_across_systems_info"
    ) {
      updateNestedState(
        network_and_communication_api_gateways,
        setnetwork_and_communication_api_gateways,
        [
          "api_gateways_to_ensure_smooth_data_flow_across_systems",
          "additional_info",
        ],
      );
    }
  };

  const handleMachineChange = (e) => {
    const { name, value, type, checked } = e.target;

    setMachine((prevState) => {
      // If it's a checkbox, use the checked value
      const newValue = type === "checkbox" ? checked : value;

      // Check if the name belongs to the nested 'available_ports' object
      if (name in prevState.available_ports) {
        return {
          ...prevState,
          available_ports: {
            ...prevState.available_ports,
            [name]: newValue,
          },
        };
      }

      // Otherwise, update the main object
      return {
        ...prevState,
        [name]: newValue,
      };
    });
  };

  const handlecompany_infoChange = (e) => {
    const { name, value } = e.target;
    setcompany_info((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSecurityChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    const infoName = name.endsWith("_info") ? name.replace("_info", "") : name;

    setsecurity_assessment((prevState) => ({
      ...prevState,
      [infoName]: {
        ...prevState[infoName],
        [type === "checkbox" ? "status" : "additional_info"]: fieldValue,
      },
    }));
  };

  const handleBusinessChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    let section, field;

    if (name.endsWith("_info")) {
      section = name.replace("_info", "");
      field = "additional_info";
    } else if (name.endsWith("_status")) {
      section = name.replace("_status", "");
      field = "status";
    } else {
      section = name;
      field = "status"; // Default case if neither _info nor _status is detected
    }

    setbusiness_assessment((prevState) => {
      const sectionName =
        section in prevState.business_goals ? "business_goals" : "use_cases";
      return {
        ...prevState,
        [sectionName]: {
          ...prevState[sectionName],
          [section]: {
            ...prevState[sectionName][section],
            [field]: fieldValue,
          },
        },
      };
    });
  };

  const handleAddOrUpdate = () => {
    if (editIndex !== null) {
      // Update the existing machine
      const updatedMachines = machines.map((m, index) =>
        index === editIndex ? machine : m,
      );
      setMachines(updatedMachines);
      setEditIndex(null);
    } else {
      // Assign a unique ID to the new machine
      const newMachine = {
        ...machine,
        id:
          machines.length > 0 ? Math.max(...machines.map((m) => m.id)) + 1 : 1, // Find the max ID and increment
      };
      setMachines([...machines, newMachine]);
    }

    resetForm();
  };

  // Handle Edit Machine
  const handleEdit = (index) => {
    const machineToEdit = machines[index];
    setMachine(machineToEdit);
    setEditIndex(index);
  };

  // Handle Save (Example for machine list)
  const handleSave = () => {
    console.log("Machines List: ", machines);
    // Here you can make an API call to save the machines list to your backend.
  };

  // Reset Machine Form
  const resetForm = () => {
    setMachine({
      id: machines.length + 1,
      machine_name: "",
      machine_function: "",
      year_of_installation: "",
      does_this_machine_use_a_plc: false,
      plc_type_or_model: "",
      is_the_plc_integrated_with_a_scada_system: false,
      scada_system: "",
      does_the_plc_support_modern_communication_protocols: false,
      protocols_in_use: "",
      available_ports: {
        status: false,
        additional_info_on_available_ports: "",
      },
      does_this_machine_have_an_associated_edge_computing_device: false,
      edge_device_specifications: "",
      data_processed: "",
      storage_capacity: "",
    });
  };

  const handleCompare = async (jsonData) => {
    if (!jsonData) {
      setError("Please provide valid JSON data");
      return;
    }

    setError("");
    setTranScript("");
    setDisplayText("");
    setAnswerload(true);
    try {
      setCompareLoad(true); // Start the loading state

      // Ensure jsonData is clean and safe for serialization
      const payload = {
        user_json: sanitizeObject(jsonData),
      };

      console.log("Payload before stringify:", payload);

      const trainOption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      const requestTrain = await fetch(
        "https://wseukkyoccyb4e5gx5f5v2ps640ceceb.lambda-url.ap-south-1.on.aws/",
        trainOption,
      );

      if (!requestTrain.ok) {
        setError(`HTTP error! status: ${requestTrain.status}`);
        console.error(`HTTP error! status: ${requestTrain.status}`);
        return;
      }

      let response;
      try {
        const responseText = await requestTrain.text(); // Get raw text
        console.log("Raw response text:", responseText);
        try {
          response = JSON.parse(responseText); // Parse the JSON manually
        } catch (jsonError) {
          throw new Error(
            "Error parsing JSON response from server: " + responseText,
          );
        }
      } catch (error) {
        setError("Error parsing or fetching JSON response from server.");
        console.error("Error parsing JSON or fetching response:", error);
        return;
      }

      // console.log("Full response:", response);

      if (response?.message) {
        setTranScript(response.message);
        setAnswerload(false);
        console.log("Response data:", response.message);
      } else {
        setError("Unexpected response structure from server.");
        console.error("Unexpected response structure:", response);
      }
    } catch (error) {
      setError("There was an error with the fetch request.");
      console.error("There was an error with the fetch request:", error);
    } finally {
      setCompareLoad(false); // End the loading state
    }
  };

  const [jsonData, setJsonData] = useState("");

  function sanitizeObject(obj) {
    const seen = new WeakSet();
    return JSON.parse(
      JSON.stringify(obj, (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return; // Remove circular reference
          }
          seen.add(value);
        }
        return value;
      }),
    );
  }

  const consolidateDataToJson = () => {
    // Deep clone the combined data to ensure no circular references
    const cleanData = _.cloneDeep({
      company_info,
      machines,
      security_assessment,
      business_assessment,
    });

    // Inspect the clean data
    console.log("Clean Data:", cleanData);

    try {
      // Stringify the clean data
      const jsonData = JSON.stringify(cleanData);
      console.log("Final JSON Data:", jsonData);

      // Set the JSON data to state or wherever needed
      setJsonData(jsonData);
    } catch (error) {
      console.error("Error stringifying JSON data:", error);
    }
  };

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  useEffect(() => {
    if (transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    consolidateDataToJson();
    setError("Information saved succesfully");
  };

  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
            <p style={{ display: "flex", justifyContent: "center" }}>
              Please check the boxes where applicable
            </p>
          </div>
          <div className="col-auto align-self-end">
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={signOut}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div className="emailsum-container" style={{ display: "block" }}>
          {/* General Information */}
          <div className="input-form" style={{ flex: "1 1", margin: "2rem" }}>
            <form>
              <h4 style={{ display: "flex", justifyContent: "center" }}>
                General Information
              </h4>
              <br />

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Company Name:</label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="text"
                    name="company_name"
                    className="form-control"
                    value={company_info.company_name}
                    onChange={handlecompany_infoChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Industry:</label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="text"
                    name="industry"
                    className="form-control"
                    value={company_info.industry}
                    onChange={handlecompany_infoChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Primary Contact Person:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="text"
                    name="primary_contact_person"
                    className="form-control"
                    value={company_info.primary_contact_person}
                    onChange={handlecompany_infoChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Location:</label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="text"
                    name="location"
                    className="form-control"
                    value={company_info.location}
                    onChange={handlecompany_infoChange}
                  />
                </div>
              </div>
            </form>
          </div>

          {/* Technical Assessment */}
          <div className="input-form" style={{ flex: "1 1" }}>
            <h4 style={{ textAlign: "center" }}>Technical Assessment</h4>
            <br />
            <h5>Machines List</h5>
            <ul>
              {machines.map((m, index) => (
                <li key={index}>
                  {m.machine_name} - {m.machine_function} -{" "}
                  {m.year_of_installation}
                  <button
                    style={{ color: "white", marginBottom: "10px" }}
                    className="btn btn-link"
                    onClick={() => handleEdit(index)}
                  >
                    Edit
                  </button>
                </li>
              ))}
            </ul>
            <form>
              {/* Machine Details */}
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Machine Name:</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="machine_name"
                    className="form-control"
                    value={machine.machine_name}
                    onChange={handleMachineChange} // Updated function name
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Machine Function:
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="machine_function"
                    className="form-control"
                    value={machine.machine_function}
                    onChange={handleMachineChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Year of Installation:
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="year_of_installation"
                    className="form-control"
                    value={machine.year_of_installation}
                    onChange={handleMachineChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Does this machine use a PLC?
                </label>
                <div className="col-sm-8">
                  <input
                    type="checkbox"
                    name="does_this_machine_use_a_plc"
                    className="form-control large-checkbox"
                    checked={machine.does_this_machine_use_a_plc}
                    onChange={handleMachineChange}
                  />
                </div>
              </div>
              {machine.does_this_machine_use_a_plc && (
                <>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      PLC Type or Model:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="plc_type_or_model"
                        className="form-control"
                        value={machine.plc_type_or_model}
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Is the PLC integrated with a SCADA system?
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="checkbox"
                        className="form-control large-checkbox"
                        name="is_the_plc_integrated_with_a_scada_system"
                        checked={
                          machine.is_the_plc_integrated_with_a_scada_system
                        }
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>
                  {machine.is_the_plc_integrated_with_a_scada_system && (
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        SCADA System:
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          name="scada_system"
                          className="form-control"
                          value={machine.scada_system}
                          onChange={handleMachineChange}
                        />
                      </div>
                    </div>
                  )}

                  {/* New fields for Communication Protocols */}
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Does the PLC support modern communication protocols?
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="checkbox"
                        name="does_the_plc_support_modern_communication_protocols"
                        className="form-control large-checkbox"
                        checked={
                          machine.does_the_plc_support_modern_communication_protocols
                        }
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Protocols in Use:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="protocols_in_use"
                        className="form-control"
                        value={machine.protocols_in_use}
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>

                  {/* Existing Available Ports section */}
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Available Ports:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="checkbox"
                        name="status"
                        className="form-control large-checkbox"
                        checked={machine.available_ports.status}
                        onChange={handleMachineChange} // Updated function name for nested object
                      />
                    </div>
                  </div>
                  {machine.available_ports.status && (
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">
                        Additional Info on Available Ports:
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          name="additional_info_on_available_ports"
                          className="form-control"
                          value={
                            machine.available_ports
                              .additional_info_on_available_ports
                          }
                          onChange={handleMachineChange} // Updated function name for nested object
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Does this machine have an associated edge computing device?:
                </label>
                <div className="col-sm-8">
                  <input
                    type="checkbox"
                    name="does_this_machine_have_an_associated_edge_computing_device"
                    className="form-control large-checkbox"
                    checked={
                      machine.does_this_machine_have_an_associated_edge_computing_device
                    }
                    onChange={handleMachineChange}
                  />
                </div>
              </div>
              {machine.does_this_machine_have_an_associated_edge_computing_device && (
                <>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Edge Device Specifications:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="edge_device_specifications"
                        className="form-control"
                        value={machine.edge_device_specifications}
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Data Processed:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="data_processed"
                        className="form-control"
                        value={machine.data_processed}
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                      Storage Capacity:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="storage_capacity"
                        className="form-control"
                        value={machine.storage_capacity}
                        onChange={handleMachineChange}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="form-group row">
                <div className="col-sm-12 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAddOrUpdate}
                  >
                    {editIndex !== null ? "Update" : "Add Machine"}
                  </button>
                  {/* <button type="button" className="btn btn-success ml-2" onClick={handleSave}>
                    Save
                  </button> */}
                </div>
              </div>
            </form>
          </div>

          {/* Security Assessment Section */}
          <div className="input-form" style={{ flex: "1 1", margin: "2rem" }}>
            <form>
              {/* Security Assessment Section */}
              <h4 style={{ display: "flex", justifyContent: "center" }}>
                Security Assessment
              </h4>
              <br />
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Security for PLCs and SCADA:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="security_for_plcs_and_scada"
                    className="form-control large-checkbox"
                    checked={
                      security_assessment.security_for_plcs_and_scada.status
                    }
                    onChange={handleSecurityChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="security_for_plcs_and_scada_info"
                    className="form-control"
                    value={
                      security_assessment.security_for_plcs_and_scada
                        .additional_info
                    }
                    onChange={handleSecurityChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Network Security:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="network_security"
                    className="form-control large-checkbox"
                    checked={security_assessment.network_security.status}
                    onChange={handleSecurityChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="network_security_info"
                    className="form-control"
                    value={security_assessment.network_security.additional_info}
                    onChange={handleSecurityChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Secure Communication Protocols:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="secure_communication_protocols"
                    className="form-control large-checkbox"
                    checked={
                      security_assessment.secure_communication_protocols.status
                    }
                    onChange={handleSecurityChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="secure_communication_protocols_info"
                    className="form-control"
                    value={
                      security_assessment.secure_communication_protocols
                        .additional_info
                    }
                    onChange={handleSecurityChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Access Controls:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="access_controls"
                    className="form-control large-checkbox"
                    checked={security_assessment.access_controls.status}
                    onChange={handleSecurityChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="access_controls_info"
                    className="form-control"
                    value={security_assessment.access_controls.additional_info}
                    onChange={handleSecurityChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Intrusion Detection Systems:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="intrusion_detection_systems"
                    className="form-control large-checkbox"
                    checked={
                      security_assessment.intrusion_detection_systems.status
                    }
                    onChange={handleSecurityChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="intrusion_detection_systems_info"
                    className="form-control"
                    value={
                      security_assessment.intrusion_detection_systems
                        .additional_info
                    }
                    onChange={handleSecurityChange}
                  />
                </div>
              </div>
            </form>
          </div>

          {/* Business Assessment Section */}
          <div className="input-form" style={{ flex: "1 1", margin: "2rem" }}>
            <form>
              <h4 style={{ display: "flex", justifyContent: "center" }}>
                Business Assessment
              </h4>
              <br />
              <h4>Business Goals</h4>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Defined Business Goals:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="defined_business_goals_status"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.business_goals.defined_business_goals
                        .status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="defined_business_goals_info"
                    className="form-control"
                    value={
                      business_assessment.business_goals.defined_business_goals
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  KPIs to Improve:
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="kpis_to_improve_info"
                    className="form-control"
                    value={
                      business_assessment.business_goals.kpis_to_improve
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              {/* Use Cases Section */}
              <h5>Use Cases</h5>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">OEE Tracking:</label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="oee_tracking"
                    className="form-control large-checkbox"
                    checked={business_assessment.use_cases.oee_tracking.status}
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="oee_tracking_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.oee_tracking.additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Predictive Maintenance:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="predictive_maintenance"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.predictive_maintenance
                        .status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="predictive_maintenance_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.predictive_maintenance
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Real-Time Production Monitoring:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="real_time_production_monitoring"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases
                        .real_time_production_monitoring.status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="real_time_production_monitoring_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases
                        .real_time_production_monitoring.additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Digital Twin Technology:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="digital_twin_technology"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.digital_twin_technology
                        .status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="digital_twin_technology_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.digital_twin_technology
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Lead Scoring Models:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="lead_scoring_models"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.lead_scoring_models.status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="lead_scoring_models_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.lead_scoring_models
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Customer Segmentation:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="customer_segmentation"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.customer_segmentation.status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="customer_segmentation_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.customer_segmentation
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Recommendation Engine:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="recommendation_engine"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.recommendation_engine.status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="recommendation_engine_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.recommendation_engine
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Inventory Optimization:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="inventory_optimization"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.inventory_optimization
                        .status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="inventory_optimization_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.inventory_optimization
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Demand Forecasting Models:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="demand_forecasting_models"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases.demand_forecasting_models
                        .status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="demand_forecasting_models_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases.demand_forecasting_models
                        .additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Real-Time Supply Chain Visibility:
                </label>
                <div className="col-sm-8 d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="real_time_supply_chain_visibility"
                    className="form-control large-checkbox"
                    checked={
                      business_assessment.use_cases
                        .real_time_supply_chain_visibility.status
                    }
                    onChange={handleBusinessChange}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <input
                    type="text"
                    name="real_time_supply_chain_visibility_info"
                    className="form-control"
                    value={
                      business_assessment.use_cases
                        .real_time_supply_chain_visibility.additional_info
                    }
                    onChange={handleBusinessChange}
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="form-group row">
            <div
              className="col-sm-12 d-flex justify-content-center"
              style={{ gap: "1rem" }}
            >
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={isFileUploaded}
              >
                SAVE
              </button>
            </div>
          </div>
          <div
            className="input-form"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "1rem auto",
              width: "400px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                accept=".txt"
                id="txt-upload"
                type="file"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <label htmlFor="txt-upload">
                <Button
                  variant="contained"
                  component="span"
                  style={{ marginRight: "1rem", height: "48px" }}
                >
                  Select Text
                </Button>
              </label>
              <Button
                variant="contained"
                color="primary"
                component="span"
                disabled={!file}
                onClick={handleUpload}
                style={{ height: "48px" }}
              >
                Upload
              </Button>
            </div>
          </div>

          <div className="form-group row">
            <div
              className="col-sm-12 d-flex justify-content-center"
              style={{ gap: "1rem" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleCompare(jsonData)}
                startIcon={
                  answerload && <CircularProgress color="white" size={20} />
                }
                disabled={transcript.length !== 0}
              >
                Generate
              </Button>
            </div>
            <div
              className="col-sm-12"
              style={{ textAlign: "center", color: "white" }}
            >
              <br />
              {error}
            </div>
          </div>
          <div
            className="input-form-chatbot"
            style={{
              flex: "0.3",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              width: "80vw",
              margin: "2rem auto",
            }}
          >
            <div className="section-container">
              <h4>
                <strong>Generated Response</strong>
              </h4>
              <hr style={{ background: "white" }}></hr>
              {displayText.length > 0 ? (
                <div
                  style={{
                    color: "white",
                    fontFamily: "sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayText }}
                ></div>
              ) : (
                "Response will be displayed here"
              )}
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have access to use this section.
        </h2>
      )}
    </div>
  );
}
